module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAABDUlEQVR4AezWA6iYYRiG4Ws+DLOVhjArzraduTSbacjmbNthtvNsh8NwkI5tffebf1y5R2UXCoWamWydwx76IFmCj+47Yr1JmhXxbpLv3rhpp+nakbcYWz2VKq2AS/XUZrHFejfNa6s1A4Cpfkgrxn01tdjv/jYDgLQKujIBiS7ZYbEhuooQoY2ehlnmhG9lB65YIFrBlQm4rTdQUQACEIAABCAAAQhANQIijbPCHne9kzkd7TJD+7IDYxyQUFHDa7jnFb7sygJ8cdp6Y3UXI0ong8y2zTn/i5iO0Fg/S5yUmBf4Ks0rc7RQUPX0sUV8saZjhGmOSvQVgK76Kk7tXSjWdIQI6VNiGBlgFAAA31aziLTYPmoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_import_contacts_black_24dp.png
// module id = 67
// module chunks = 0